module.exports = __webpack_public_path__ + "img/showcase-stats-en-us.1bc4d195.jpg";